import React, { useState, useEffect } from 'react'
import 'react-toastify/ReactToastify.css'
import { toast } from 'react-toastify'
import SmartTextField from './SmartTextField'
import RadioList from './RadioList'
import './AddLessonForm.css'
import { useCookies } from 'react-cookie'

function AddLessonForm({ clickHandler, createHandler, modifyingLesson }) {
    const [ materii, setMaterii ] = useState([])
    const [ profesori, setProfesori ] = useState([])
    const [ cookies, setCookie ] = useCookies(['user-prefs'])

    /* 
        asta e asa mai mult de 'finete', ca iti ofera sugestii
        in functie de profesorii si materiile introduse pe orarapp
    */
    useEffect(() => {
        const loadMaterii = async () => {
            const req = await fetch(`/api/materii`)
            const res = await req.json()
            const nume = res.map(materie => materie.denumire)

            setMaterii(nume)
            // console.table(res)
        }

        const loadProfesori = async () => {
            const req = await fetch(`${process.env.REACT_APP_API_ROOT}/api/profesori`)
            const res = await req.json()
            const nume = res.map(profesor => `${profesor.nume} ${profesor.prenume}`)
            
            setProfesori(nume)
            // console.table(res)
        }

        try {
            if(modifyingLesson == null) {
                loadMaterii()
                loadProfesori()
            }
        } catch(err) {
            console.error(err)
        }
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault()

        const formData = new FormData(e.target)
        const formProps = Object.fromEntries(formData)
        
        const getAn = () => {
            const year = formProps['add-lesson-year']
            return year[year.length - 1]
        }

        const inputs = {
            dateOfMeeting: formProps['cons-data'],
            timeOfMeeting: formProps['cons-ora'],
            year: getAn(),
            studentBatch: formProps['add-serie'],
            subject: formProps['add-materie'],
            meetingLink: formProps['add-link'],
            driveLink: formProps['add-drive'],
            professor: formProps['add-profesor']
        }

        const requestData = {
            type: (modifyingLesson) ? `PUT` : `POST`,
            link: (modifyingLesson)
                    ? `${process.env.REACT_APP_API_ROOT}/api/consultation/update/${modifyingLesson.id}`
                    : `${process.env.REACT_APP_API_ROOT}/api/consultation/create`
        }

        /* nu am testat cu autentificarea deci nu sunt sigur ca merge */
        const res = await fetch(requestData.link, {
            method: requestData.type,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(inputs)
        })

        if(res.status == 200) {
            toast.success(`Consultatia a fost ${(modifyingLesson) ? 'actualizata' : 'adaugata'} cu succes`, { position: 'top-center' })
            createHandler(e)
        } else {
            const errors = await res.json()
            console.error(errors)
            toast.error(`Eroare: ${errors.message}`, { position: `top-center` })
        }

        clickHandler(e)
    }

    const getDataText = (date) => {
        const d = (date) ? new Date(date) : new Date()
        let zi = d.getDate().toString()
        if(zi.length == 1)
            zi = `0${zi}`
        
        let luna = (d.getMonth() + 1).toString()
        if(luna.length == 1)
            luna = `0${luna}`

        return `${d.getFullYear()}-${luna}-${zi}`
    }

    return <>
        <form id="add-lesson-form" onSubmit={handleSubmit}>
            <i
                className="fas fa-times fa-2x close-new-form"
                id="close-form-btn"
                onClick={clickHandler}
            ></i>

            <h2 style={{
                fontSize: "34px", 
                fontWeight: "normal"
            }}>{(modifyingLesson) ? "Modifică o consultație existentă" : "Adaugă o nouă consultație"}</h2>
            <div id="add-lesson-date">
                <input
                    type={cookies.useOldForm ? "text" : "date"}
                    name="cons-data"
                    id="cons-data"
                    defaultValue={getDataText((modifyingLesson) ? modifyingLesson.data : null)}
                    required
                />
                <input 
                    type={cookies.useOldForm ? "text" : "time"} 
                    name="cons-ora" 
                    id="cons-ora"
                    defaultValue={(modifyingLesson) ? modifyingLesson.ora : `${new Date().getHours()}:${new Date().getMinutes()}`}
                    required
                />
            </div>

            <div id="add-lesson-years">
                <RadioList
                    name="add-lesson-year"
                    values={
                        [ 
                            { name: `Anul I`, key: `an-1`, value: 1 },
                            { name: `Anul II`, key: `an-2`, value: 2 },
                            { name: `Anul III`, key: `an-3`, value: 3 }
                        ]
                    }
                    defaultValue={(modifyingLesson) ? modifyingLesson.an : -1}
                />
                <SmartTextField
                    key="add-serie"
                    name="add-serie"
                    placeholder="Serie"
                    defaultValue={(modifyingLesson) ? modifyingLesson.serie : null}
                />
            </div>

            <div id="add-lesson-course">
                <SmartTextField
                    key="add-materie"
                    name="add-materie"
                    placeholder="Materie"
                    defaultValue={(modifyingLesson) ? modifyingLesson.materie : null}
                    values={(cookies.disableSuggestions) ? [] : materii}
                />

                <SmartTextField
                    key="add-profesor"
                    name="add-profesor"
                    placeholder="Profesor"
                    defaultValue={(modifyingLesson) ? modifyingLesson.profesor : null}
                    values={(cookies.disableSuggestions) ? [] : profesori}
                />
            </div>

            <div id="add-lesson-links">
                <SmartTextField
                    key="add-link"
                    name="add-link"
                    placeholder="Link"
                    defaultValue={(modifyingLesson) ? modifyingLesson.link : null}
                    values={['https://ase.zoom.com/', 'https://zoom.com/']}
                    type="url"
                />

                <SmartTextField
                    key="add-drive"
                    name="add-drive"
                    placeholder="Materiale"
                    defaultValue={(modifyingLesson) ? modifyingLesson.materiale : null}
                    values={['https://drive.google.com/']}
                    type="url"
                />
            </div>

            <input className="submit-btn" type="submit" value={(modifyingLesson) ? `Modifică` : `Adaugă`} />
        </form>
    </>
}

export default AddLessonForm